export const Translations = {
    methods: {
        /**
         * Translate the given key.
         */
        ___(key, replace = {}) {
            // var translation = window._translations[key]
            //     ? window._translations[key]
            //     : key
            var keySplit = key.split("|");
            var translation = window._translations[keySplit[0]][keySplit[1]][keySplit[2]]
                ? window._translations[keySplit[0]][keySplit[1]][keySplit[2]]
                : null

            Object.keys(replace).forEach(function (key) {
                translation = translation.replace(':' + key, replace[key])
            });

            return translation
        },

        /** 
        * Translate the given key with basic pluralization. 
        */
        ___n(key, number, replace = {}) {
            var options = key.split('|');

            key = options[1];
            if (number == 1) {
                key = options[0];
            }

            return tt(key, replace);
        },
    },
   
}